<template>
    <div class="full-height">
        <div v-if="showBox" class="box1">
            <div style="background-color: #4A525D;">
                <span class="hover head" @click="back">
                    <i class="el-icon-arrow-left" style="font-weight: 600; font-size: 16px;"></i> 
                    <span style="color: white;" >01 成功写出你的第一个代码 </span>
                </span>
            </div>
            <div style="background-color: #3D444C; height: 50px;">
                <span class="body" style="padding-left: 20px; font-size: 16px;">课程学习</span>
                <span class="body" style="float: right; padding-right: 10px; font-size: 14px;">共{{ list.length }}节</span>
            </div>
            <div class="hh itemm" v-for="l in list" :key="l.id" @click.prevent="toRouter(l)">
                <div style="word-wrap: break-word; width: 100%; color: white; line-height: auto;">
                    <i class="el-icon-video-play" style="color: white;"></i> 
                    {{ l.title }}
                </div>
            </div>
        </div>
        <div class="box2" :style="{ width: box2Width, marginLeft: rightMargin }">
            <div class="header">
                <i v-show="showBox" class="el-icon-s-fold" style="padding-left: 20px; font-size: 23px; color: #36A594; cursor: pointer;" @click="toggleBoxes"></i>
                <i v-show="!showBox" class="el-icon-s-unfold" style="padding-left: 20px; font-size: 23px; color: #36A594; cursor: pointer;" @click="toggleBoxes"></i>
                <span style=" width:100%; text-align: center; color: white;">
                    第 {{ number }} 节 {{ title }}
                </span>
            </div>
            <div style="margin: 0 auto;">
                <!-- <router-view style="margin: 0 auto;" ref="son"></router-view> -->
                <Video v-if="isShow" :info="info"></Video>
                <TalkAbout></TalkAbout>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url';
    import Video from './Video.vue';
    import TalkAbout from './TalkAbout.vue';
    export default {
        components: {
            Video,
            TalkAbout
        },
        data() {
          return {
            showBox: true, // 控制左右两侧div的
            box2Width: '100vw',
            rightMargin: '225px',

            // 上面的别管
            isShow: false,
            list:[], // 所有课程视频信息

            title:'',
            number:'',
            id:'',
            info:{},
          };
        },
        mounted() {
            console.log("课程id: ", this.$route.params.id)
            console.log("目录id: ", this.$route.params.catalogId)
            // 然后根据目录id来找到对应的视频List
        
            this.ReadVideo()
            this.ReadOneCourseVideo()
        },
        methods: {
            ReadOneCourseVideo() { // 获取单个课程视频信息
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url: Url.rOneCourseVideoUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: route.params.Vid, // 课程id
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.info = JSON.parse(resp.courseVideo)
                            console.log("courseVideo == >", vue.info)
                            vue.isShow = true
                            vue.number = vue.info.number
                            vue.title = vue.info.title
                        } 
                    },
                    error(resp) {
                        console.log("获取课程视频彻底失败了, resp == >", resp)
                    }
                })
            },
            ReadVideo() { // 获取课程视频
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url: Url.rCourseVideoUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        catalogId: route.params.catalogId, // 目录id
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                        } 
                    },
                    error(resp) {
                        console.log("获取课程视频彻底失败了, resp == >", resp)
                    }
                })
            },
            back() {
                this.$router.push({
                    name:'programmes',
                    params: {
                        id: this.$route.params.id
                    }
                })
            },
            toggleBoxes() {
                this.rightMargin = this.showBox ? '0' : '225px'; // 调整右侧 margin
                this.showBox = !this.showBox;
                this.box2Width = this.showBox ? '100vw' : 'calc(100vw - 225px)';
            },
            toRouter(item) {
                this.title = item.title
                this.number = item.number

                const id = this.$route.params.id
                const catalogId = this.$route.params.catalogId
                const Vid = item.id

                console.log("去这里了 == >", `/programmes/videoing/${id}/${catalogId}/${Vid}`)
                if (this.$route.path !== `/programmes/videoing/${id}/${catalogId}/${Vid}`)
                {
                    this.$router.push({
                        path:`/programmes/videoing/${id}/${catalogId}/${Vid}`,
                        params: {
                            id: id,
                            catalogId: catalogId,
                            Vid: item.id,
                        }
                    })
                    window.location.reload() // 刷新一下页面捏
                }
            }
        }
    };
</script>

<style scoped>
.header {
    width: 100%;
    height: 50px;
    background-color: #30363E;
    display: flex;
    align-items: center;
}


.itemm {
    background-color: #4A525D; 
    min-height: 50px; 
    height: auto; 
    padding: 7px 10px 7px 20px; 
    display: flex; 
    align-items: center;
}
.hh:hover {
    background-color: #505864;
}
.body {
    height: 50px; 
    line-height: 50px; 
    font-size: 14px;
    color: #FFFFFF;
}
.head {
    height: 50px; 
    line-height: 50px; 
    font-size: 14px; 
    color: #FFFFFF; 
    padding-left: 20px; 
    cursor: pointer;
}
.hover:hover {
    color: rgb(90, 164, 90);
}
.full-height {
  display: flex;
  height: 100vh;
}

.box1 {
  width: 225px;
  height: 100vh;
  background-color: #4A525D;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
}

.box2 {
  position: relative;
  flex-grow: 1;
}
</style>